import { render, staticRenderFns } from "./CallPhoneDialog.vue?vue&type=template&id=190fc21c&scoped=true"
import script from "./CallPhoneDialog.vue?vue&type=script&lang=js"
export * from "./CallPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./CallPhoneDialog.vue?vue&type=style&index=0&id=190fc21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fc21c",
  null
  
)

export default component.exports